import { connect } from "react-redux"
import ChangeDateCalendar from "../../components/history/change-date-calendar"

const mapStateToProps = state =>({
  isActive: state.transactionsHistory.isChangeDateActive,
  selectedDate: state.transactionsHistory.newTransactionDate
})

const mapDispatchToProps = dispatch => ({
  onCancel: () => dispatch({type: "TRANSACTIONS_HISTORY.CANCEL_NEW_DATE"}),
  onChangeDate: (date) => dispatch({type: "TRANSACTIONS_HISTORY.CHANGE_NEW_DATE", payload: {date}}),
  onConfirm: () => dispatch({type: "TRANSACTIONS_HISTORY.CONFIRM_NEW_DATE"}),
  onShowCalendar: () => dispatch({type: "TRANSACTIONS_HISTORY.TOGGLE_CHANGE_DATE"}),
})

export default connect(mapStateToProps, mapDispatchToProps)(ChangeDateCalendar)
